import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeStandbyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode_standby"}/>
}
